import React, { useMemo, useState } from "react";
import { Control } from "react-hook-form";
import InputField from "components/UI/InputField/InputField";
import {
  FIELD_VAL_NAMES,
  UNIT_FIELD_HM_VAL_NAMES,
  UNIT_FIELD_VAL_NAMES,
} from "constant/dl_unit/dl_unit_field.constant";
import FormFieldContainer from "components/layout/style/form/FormFieldContainer";
import type { UnitFormState } from "../UnitForm";
import styled from "styled-components";
import NavText from "components/common/style/navigation/NavText";

type UnitFormFieldSectionProps = {
  control: Control<UnitFormState>;
};

const UnitFormFieldSection = ({ control }: UnitFormFieldSectionProps) => {
  const [onlyHMFields, setOnlyHMFields] = useState<boolean>(false);
  const fieldNames = useMemo<string[]>(() => {
    return onlyHMFields ? UNIT_FIELD_HM_VAL_NAMES : UNIT_FIELD_VAL_NAMES;
  }, [onlyHMFields]);

  const showAllFields = () => setOnlyHMFields(false);
  const showOnlyHMFields = () => setOnlyHMFields(true);

  return (
    <Div>
      <DivNav>
        <NavText onClick={showAllFields}>ALL</NavText>
        <NavText onClick={showOnlyHMFields}>HM</NavText>
      </DivNav>
      {fieldNames.map((fieldName) => (
        <FormFieldContainer key={fieldName}>
          <InputField
            name={`fVals.${fieldName}`}
            control={control}
            label={fieldName.replace("_", " ")}
            id={`fVals-${fieldName}`}
            inputLabelShrink
            autoFocus={false}
          />
        </FormFieldContainer>
      ))}
    </Div>
  );
};

const Div = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
`;

const DivNav = styled.div`
  display: flex;
  gap: 1rem;
`;

export default UnitFormFieldSection;
